// @flow
import { combineReducers } from 'redux';
import { CREATE_LINE, UPDATE_LINE, DELETE_LINE } from '../actions/line';
import type { LineType, EntityActionType } from '../types';

export function getUpdatedLine(origLine: LineType, newLine: LineType): LineType {
  return {
    ...origLine,
    text: newLine.text !== null ? newLine.text : origLine.text,
    syllables: newLine.syllables === undefined ? origLine.syllables : newLine.syllables,
    stresses: newLine.stresses === undefined ? origLine.stresses : newLine.stresses,
  };
}

const emptyLine = {
  text: '',
  syllables: null,
  stresses: null,
};

type ByIdType = { [number]: LineType };
type AllIdsType = Array<number>;

export default combineReducers({
  byId: (state: ByIdType = {}, action: EntityActionType): ByIdType => {
    switch (action.type) {
    case CREATE_LINE:
      return {
        ...state,
        [action.obj.id]: { ...emptyLine, ...action.obj },
      };
    case UPDATE_LINE:
      return {
        ...state,
        [action.obj.id]: getUpdatedLine(state[action.obj.id], action.obj),
      };
    case DELETE_LINE: {
      const newState = { ...state };
      delete newState[action.id];
      return newState;
    }
    default:
      return state;
    }
  },

  allIds: (state: AllIdsType = [], action: EntityActionType): AllIdsType => {
    switch (action.type) {
    case CREATE_LINE: {
      const newState: AllIdsType = [...state];
      if (action.index === undefined) {
        newState.push(action.obj.id);
      } else {
        newState.splice(action.index, 0, action.obj.id);
      }
      return newState;
    }
    case DELETE_LINE: {
      return state.filter(id => id !== action.id);
    }
    default:
      return state;
    }
  },
});



// WEBPACK FOOTER //
// ./src/reducers/lines.js